module.exports = __webpack_public_path__ + "static/media/result2.abbc57b7.png";